import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IReExamPracticelistID } from "../../../Pages/Exam/IExam";
import { IPendingPracticeExam } from "../../../Pages/DashboardUser/IDashboardUser";

export const ListReExamPracticeSlice = createSlice({
  name: "ListReExamPracticeIDSlice",
  initialState: {} as IReduxState<IPendingPracticeExam[]>,
  reducers: {
    listReExamPracticeID: (state, _: PayloadAction<IReExamPracticelistID>) => {
      state.isLoading = true;
    },
    successlistReExamPracticeID: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistReExamPracticeID: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearListReExamPracticeID: (state) => {
      state.data = {};
    },
  },
});

export const {
  failurelistReExamPracticeID,
  listReExamPracticeID,
  successlistReExamPracticeID,
  clearListReExamPracticeID,
} = ListReExamPracticeSlice.actions;

export default ListReExamPracticeSlice.reducer;
